import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LayoutSplashScreen from "src/layout/common/LayoutSplashScreen";

const TokenHandler = ({ children }: any) => {
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      const isLocalEnvironment = process.env.NODE_ENV === "development";
      if (isLocalEnvironment) {
        console.log(
          "Running in local environment, skipping token verification"
        );
        setIsVerifying(false);
        return;
      }
      try {
        await axios.get("/verify-token", { withCredentials: true });
        setIsVerifying(false);
      } catch (error) {
        console.error("Error verifying token:", error);
        setIsVerifying(false);
        navigate("/login");
      }
    };

    verifyToken();
  }, [navigate]);

  return isVerifying ? <LayoutSplashScreen /> : <>{children}</>;
};

export default TokenHandler;
